<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/news' }">
        <app-i18n code="entities.news.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.news.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.news.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.news.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.news.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.title.label"
          :prop="fields.title.name"
          :required="fields.title.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.title.name]" ref="focus" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.subtitle.label"
          :prop="fields.subtitle.name"
          :required="fields.subtitle.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.subtitle.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.contentHtml.label"
          :prop="fields.contentHtml.name"
          :required="fields.contentHtml.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.contentHtml.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.description.label"
          :prop="fields.description.name"
          :required="fields.description.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.description.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.sourceUrl.label"
          :prop="fields.sourceUrl.name"
          :required="fields.sourceUrl.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.sourceUrl.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.media.label"
          :prop="fields.media.name"
          :required="fields.media.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-file-upload
              :max="fields.media.max"
              :path="fields.media.path"
              :schema="fields.media.fileSchema"
              v-model="model[fields.media.name]"
            ></app-file-upload>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.status.label"
          :prop="fields.status.name"
          :required="fields.status.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-select placeholder v-model="model[fields.status.name]">
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.status.options"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.propertyOwner.label"
          :prop="fields.propertyOwner.name"
          :required="fields.propertyOwner.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :fetchFn="fields.propertyOwner.fetchFn"
              v-model="model[fields.propertyOwner.name]"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { NewsModel } from '@modules/news/news-model';

const { fields } = NewsModel;
const formSchema = new FormSchema([
  fields.id,
  fields.title,
  fields.subtitle,
  fields.contentHtml,
  fields.description,
  fields.sourceUrl,
  fields.media,
  fields.status,
  fields.propertyOwner,
]);

export default {
  name: 'app-news-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'news/form/record',
      findLoading: 'news/form/findLoading',
      saveLoading: 'news/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'news/form/doFind',
      doNew: 'news/form/doNew',
      doUpdate: 'news/form/doUpdate',
      doCreate: 'news/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
